const getSum = (inputs: string[]) => {
  return inputs.map(Number).reduce((sum, el) => sum + el, 0)
}

const constrain = (v: number) => Math.min(Math.max(0, v), 10)

export const cal엄격 = (inputs: string[]) => {
  return constrain(
    getSum([
      inputs[7 - 1],
      inputs[14 - 1],
      inputs[22 - 1],
      inputs[27 - 1],
      inputs[33 - 1],
    ]) / 2.5,
  )
}

export const cal물렁 = (inputs: string[]) => {
  return constrain(
    getSum([
      inputs[6 - 1],
      inputs[13 - 1],
      inputs[18 - 1],
      inputs[21 - 1],
      inputs[26 - 1],
      inputs[32 - 1],
    ]) / 3,
  )
}

export const cal버럭 = (inputs: string[]) => {
  return constrain(
    getSum([
      inputs[5 - 1],
      inputs[9 - 1],
      inputs[16 - 1],
      inputs[23 - 1],
      inputs[28 - 1],
      inputs[31 - 1],
    ]) / 3,
  )
}

export const cal고독 = (inputs: string[]) => {
  return constrain(
    (getSum([
      inputs[2 - 1],
      inputs[11 - 1],
      inputs[19 - 1],
      inputs[25 - 1],
      inputs[29 - 1],
    ]) +
      getSum([inputs[1 - 1], inputs[10 - 1], inputs[17 - 1], inputs[24 - 1]]) *
        1.25) /
      5,
  )
}

export const cal콩콩 = (inputs: string[]) => {
  return constrain(
    getSum([
      inputs[3 - 1],
      inputs[4 - 1],
      inputs[8 - 1],
      inputs[12 - 1],
      inputs[15 - 1],
      inputs[20 - 1],
      inputs[30 - 1],
      inputs[34 - 1],
    ]) / 4,
  )
}
